export default __webpack_public_path__ + "static/media/am.02f05e2b.svg";